const animationFrameHandler = [];
function animationFrame(time) {
    for (let i = 0; i < animationFrameHandler.length; i++)
        if (!animationFrameHandler[i][1](time))
            animationFrameHandler.splice(i--, 1);
    if (animationFrameHandler.length)
        window.requestAnimationFrame(animationFrame);
}
export function registerFrameHandler(handler) {
    const id = Math.random() * 1000000;
    animationFrameHandler.push([id, handler]);
    if (animationFrameHandler.length === 1)
        window.requestAnimationFrame(animationFrame);
    return id;
}
export function unregisterFrameHandler(id) {
    if (id == undefined)
        return;
    const idx = animationFrameHandler.findIndex(([i, _]) => i === id);
    if (idx >= 0)
        animationFrameHandler.splice(idx, 1);
}
export function hasFrameHandler(id) {
    if (id == undefined)
        return false;
    return animationFrameHandler.findIndex(([i, _]) => i === id) != -1;
}
